import delegate from 'delegate'

// Smooth scrolls to anchor element

const offset = -25

export default function () {
  delegate('a[href^="#"]', 'click', e => {
    e.preventDefault()
    const $section = document.querySelector(e.target.hash)
    if ($section) {
      window.scroll({
        top: $section.offsetTop - offset,
        behavior: 'smooth'
      })
    }
  }, false)
}